import { render, staticRenderFns } from "./ParticipationFeedback.vue?vue&type=template&id=6edade11&scoped=true&"
import script from "./ParticipationFeedback.vue?vue&type=script&lang=ts&"
export * from "./ParticipationFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edade11",
  null
  
)

export default component.exports